module.exports = __webpack_public_path__ + "static/media/logo-blue.dd47769e.svg";